import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js'
import './nlp/tabler.css';


function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring( o ){ return typeof(o) == 'string';}
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}


function Test(prop) {

    var global = window.GlobalVars;
    var tab;

	function editUser( user, add )
	{
		var origUser = clone(user);
	    function cb(ev)
	    {
			console.log( 'CALLBACK', user )
			if( !user.name || !user.name.trim() ) { alert( 'User Name is required' ); return false; }
			if( !user.email || !user.email.trim() || !frm.ckEmail(user.email)) { alert( 'Valid User Email is required' ); return false; }
			var updateData = {
				_new: add || false,
				name: user.name,
				email: user.email,
				company: user.company,
				priv: user.priv,
				active: user.active ? true : false,
				resetPassword: user.resetPassword,
			};
	        window.post( 'update_user', {user:updateData}, function(res){
	            // console.log( 'UPDATE USER', res )
	            if( res.data.status )
	            {
					window.GlobalVars.userTableCtx = tab.ctx();
					window.saveSession();
					setTimeout( function(){document.location.reload();},200 );
	            }
	            else alert( 'error');
				// frm.myAlertClose();
	        });
			return false;
	    }
		if( Date.now() > user.resetTimeout ) user.resetPassword = null;
		var content = `
		<div id="userdetails">
		<input placeholder="User Email" type="email" id="email" class="mb-4 form-control">
		<input placeholder="User Name" type="text" id="name" class="mb-4 form-control">
		<input placeholder="Company Name (optional)" type="text" id="company" class="mb-4 form-control">
		<div id="userActive"></div>
		<div id="userPrivs"></div>
		<input placeholder="Temporary Password (optional)" type="text" id="resetPassword" class="mb-4 form-control">
		</div>
		`;

		function changed()
		{
		}

		function close()
		{

		}
		var btnName = add ? 'Add User' : 'Update User'
		frm.myAlert( 'User: ' + user.email, content, btnName, cb, 'Cancel', close );
		if( !add ) $('#userdetails').find('#email').remove();

		['email','name','company','resetPassword'].forEach( n =>
		{
			$('#userdetails').find('#'+n).val( user[n] ).on('change', function(){
				var id = $(this).prop('id');
				var val = $(this).val();
				console.log( 'change', id, val );
				user[id] = val;
				changed();
			})
		})

		// frm.booleanList( $('#userActive'), user)
		frm.booleanList( $('#userActive'), user, {
			items: {
				'active': { default: false, label: 'User Active' },
			},
			callbackOnInit: false,
		}, function(o){
			user.active = o.active;
			changed()
		});

		var userPrivs = frm.arr2Bool(user.priv.split(','));
		var privItems = {};
		for( var p in window.privs ) privItems[p] = { default: false, label: window.privs[p] };
		console.log( userPrivs, privItems );
		frm.booleanList( $('#userPrivs'), userPrivs, {
			items: privItems,
			header: ['','Privileges'],
			callbackOnInit: false,
		}, function(o){
			var npriv = [];
			for( var p in o ) if(o[p]) npriv.push(p);
			user.priv = npriv.join(',');
			console.log( 'privs', o, user.priv );
			changed();
		} );
	    return false;
	}





    useEffect( function(a){
        $('#topbuttons').html('');

        var match = {};
		window.post( 'find_users', {match:match}, function(res){
			console.log( 'users', res.data );
			var users = res.data.records;
			if( !users.length )
			{
				$('.alert').remove();
				var empty = $('<div role="alert" class="fade alert alert-danger show">').html('No documents found');
				$('#topbuttons').prepend(empty);
				$('#documentlist').hide();
			}
            var desc = {
                title: 'Project Files',
                columns: {
	                // _id: 'Id',
                    name: 'Name',
                    email: 'Email',
					company: 'Company',
                    priv: 'Priv.',
					created: 'Created',
                    lastLogin: 'Last Login',
					active:'Active',
                },
                filter: true,
                search: true,
                sort: true,
                // sortAlias: { lastLoginDelta: 'lastLogin' },
                initialSort: 'lastLogin',
                initialSortDir: -1,
                pageSize: 10,
                // noFilter: ['lastLogin'],
                noSearch: null,
                noSort: null,
                centerCol: ['created','lastLogin','active'],
				format: tabler.formatString,
				formatCol: {
					lastLogin:tabler.formatTimeAgo,
					created:tabler.formatDate,
					priv:tabler.formatPriv,
					active: tabler.formatActive,
				},
				headerClick: 'filter',
                // clickCol: ['stateLabel','source'],
            }
            tab = tabler.table($('#documentlist'), desc, global.userTableCtx );
            users.forEach( a => {
                a.stateLabel = '<span class="state_'+a.state+'">' + a.stateLabel + '</span>';
                tab.addRow(a, function( col, row ){
                    console.log( 'tabler click', a._id, row[col], row )
					editUser( row );
                    // fileClickTabler( col, row )
                })
            });
            tab.draw();
            console.log( 'desc', desc, 'tabler', tabler.formatString )
        });

    });

    return (
        <div fluid="md p-0" className="maincontent">
        <div id="topbuttons"></div>
        <Table id="documentlist" bordered hover size="sm" className="table-grid mt-3">
        </Table>
        <span>&nbsp;</span>
        </div>
    )
}

export default Test
